import { format, addMinutes } from 'date-fns'

const appointmentDefaults = {
  patientType: 'registered',
  newPatient: {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    heardFrom: '',
  },
  registeredPatient: {},
  doctorId: '',
  typeId: '',
  roomId: '',
  virtual: false,
  duration: '',
}

const timeOffDefaults = {
  type: 'clinic',
  clinicId: '',
  doctorId: '',
  roomId: '',
  virtual: false,
  notes: '',
}

const toDate = startDate => {
  if (!startDate) return new Date()
  return typeof startDate === 'string' ? new Date(startDate) : startDate
}

const roundDownToQuarter = date => {
  const rounded = new Date(date)
  rounded.setMinutes(rounded.getMinutes() - (rounded.getMinutes() % 15), 0, 0)
  return rounded
}

export const getAppointmentState = ({
  registeredPatient,
  doctorId,
  roomId,
  virtual,
  startDate,
  contactMethod,
}) => {
  const startsAtDate = roundDownToQuarter(toDate(startDate))

  return {
    ...appointmentDefaults,
    registeredPatient: registeredPatient || {},
    virtual: virtual || appointmentDefaults.virtual,
    doctorId: doctorId || appointmentDefaults.doctorId,
    roomId: roomId || appointmentDefaults.roomId,
    startsAtDate,
    startsAtTime: format(startsAtDate, 'hh:mm aa'),
    contactMethod: contactMethod || null,
  }
}

export const getTimeOffState = (
  clinicId,
  { doctorId, roomId, virtual, startDate }
) => {
  const startsAtDate = roundDownToQuarter(toDate(startDate))

  return {
    ...timeOffDefaults,
    clinicId: clinicId,
    doctorId: doctorId || timeOffDefaults.doctorId,
    roomId: roomId || timeOffDefaults.roomId,
    virtual: virtual,
    startsAtDate,
    startsAtTime: format(startsAtDate, 'hh:mm aa'),
    endsAtTime: format(addMinutes(startsAtDate, 30), 'hh:mm aa'),
  }
}
